import RevenueReport from '@website/components/admin/RevenueReport/RevenueReport';
import { RevenueReportType } from '@website/types/graphqlOperations';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
import { Nav } from 'react-bootstrap';
import AdminLayout from '../../components/layouts/adminLayout';

const tabName = 'reportType';

export default function RevenueReportDashboard() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  const activeTab =
    (searchParams.get(tabName) as RevenueReportType) || RevenueReportType.DAILY;

  const setActiveTab = useCallback(
    (tab: RevenueReportType) => {
      const newSearchParams = new URLSearchParams(searchParams.toString());
      newSearchParams.set(tabName, tab);
      router.push(`${pathname}?${newSearchParams.toString()}`);
    },
    [pathname, router, searchParams],
  );

  return (
    <AdminLayout>
      <Nav variant="tabs" className="my-2" defaultActiveKey={'recent-bookings'}>
        <Nav.Item key="recent-bookings">
          <Nav.Link
            active={activeTab === RevenueReportType.DAILY}
            role="button"
            onClick={() => setActiveTab(RevenueReportType.DAILY)}
          >
            Daily
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            active={activeTab === RevenueReportType.MONTHLY}
            role="button"
            onClick={() => {
              setActiveTab(RevenueReportType.MONTHLY);
            }}
          >
            Monthly
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            active={activeTab === RevenueReportType.QUARTERLY}
            role="button"
            onClick={() => {
              setActiveTab(RevenueReportType.QUARTERLY);
            }}
          >
            Quarterly
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            active={activeTab === RevenueReportType.ANNUAL}
            role="button"
            onClick={() => {
              setActiveTab(RevenueReportType.ANNUAL);
            }}
          >
            Annual
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            active={activeTab === RevenueReportType.OVERALL}
            role="button"
            onClick={() => {
              setActiveTab(RevenueReportType.OVERALL);
            }}
          >
            Overview
          </Nav.Link>
        </Nav.Item>
      </Nav>

      {activeTab === RevenueReportType.OVERALL && (
        <div className="text-center text-muted py-3">
          <p>Includes only data from January, 2023</p>
        </div>
      )}

      <RevenueReport type={activeTab} />
    </AdminLayout>
  );
}
